import { createSelector } from 'reselect';
import { MISSING_PERMISSION } from '../../../omnibus/public/constants';
import { getOmnibusRequestError } from '../../../omnibus/public/selectors';
export const isMissingInboxPermission = createSelector([getOmnibusRequestError], omnibusRequestError => {
  return Boolean(omnibusRequestError && omnibusRequestError.includes(MISSING_PERMISSION));
});